export const useLocalStorageMethod = <Type extends object>() => {
    const getLocalData = (keyName: string, handler?: (d: Type) => Type): Type => {
        if (typeof window === "undefined") {
            return {} as Type;
        }

        const data = localStorage.getItem(keyName);

        if (!data || data === "undefined" || data === "null") {
            return {} as Type;
        }

        try {
            const result = JSON.parse(data) as Type;
            return handler ? handler(result) : result;
        } catch {
            return {} as Type;
        }
    };

    const setLocalData = (keyName: string, data: Type) => {
        if (typeof window === "undefined") return;
        if (data === undefined) return; // don't store undefined
        localStorage.setItem(keyName, JSON.stringify(data));
    };

    const removeLocalData = (keyName: string) => {
        if (typeof window === "undefined") return;
        localStorage.removeItem(keyName);
    };

    return { getLocalData, setLocalData, removeLocalData };
};
